import type { ReactNode } from "react";
import { useFeature } from "../context/FeatureFlagContext";
import type { FeatureFlag } from "../config/features";

export function FeatureGate({
  flag,
  children,
}: {
  flag: FeatureFlag;
  children: ReactNode;
}) {
  const enabled = useFeature(flag);
  if (!enabled) return null;
  return <>{children}</>;
}
